import { Colors } from './types';

export const gray: Partial<Colors> = {
  lighten5: '#fef8fa',
  lighten4: '#f9f3f5',
  lighten3: '#f2eced',
  lighten2: '#e3dedf',
  lighten1: '#c0babc',
  base: '#a19b9d',
  darken1: '#777374',
  darken2: '#6b6b69', //#635f60
  darken3: '#494546', //#444041
  darken4: '#231f20',
};

export const orange: Partial<Colors> = {
  lighten5: '#fef2e1',
  lighten4: '#fcdeb5',
  lighten3: '#fac985',
  lighten2: '#f8b357',
  lighten1: '#f6a337',
  base: '#f49424',
  darken1: '#f08922',
  darken2: '#e97a1f',
  darken3: '#e26b1d',
  darken4: '#d7541b',
};
